import { useEffect, useState } from "react";
import Button from "../ui/Button";
import Text from "../../../../components/ui/Text";
import Player from "./Player";
import SetRoleModal from "./SetRoleModal";
import DeletePlayerModal from "./DeletePlayerModal";
import AddPlayerModal from "./AddPlayerModal";

export type PlayerType = {
  id: string;
  profilePicture?: string;
  name: string;
  role: string;
};

interface Props {
  className?: string;
}

const Players = ({ className = "" }: Props) => {
  const [players, setPlayers] = useState<PlayerType[]>([
    { id: "1", name: "R. Richardson", role: "Admin" },
    { id: "2", name: "A. Richardson", role: "Moderator" },
    { id: "3", name: "B. Richardson", role: "Owner" },
    { id: "4", name: "C. Richardson", role: "Police" },
    { id: "5", name: "D. Richardson", role: "Attacker" },
    { id: "6", name: "E. Richardson", role: "Guest" },
    { id: "7", name: "F. Richardson", role: "Guest" },
    { id: "8", name: "G. Richardson", role: "Guest" },
  ]);

  const [modal, setModal] = useState<
    "set-role" | "delete-player" | "add-player" | null
  >(null);
  const [selectedPlayer, setSelectedPlayer] = useState<PlayerType | null>(null);

  useEffect(() => {
    // fetchPlayers().then(setPlayers);
  }, []);

  /** Close modal and clear selected player */
  const closeModal = () => {
    setModal(null);
    setSelectedPlayer(null);
  };

  /** Update a player's role */
  const editPlayer = (player: PlayerType, newRole: string) => {
    setPlayers((prevPlayers) =>
      prevPlayers.map((p) => (p.id === player.id ? { ...p, role: newRole } : p))
    );
    closeModal();
  };

  /** Delete a player */
  const deletePlayer = (player: PlayerType) => {
    setPlayers((prevPlayers) => prevPlayers.filter((p) => p.id !== player.id));
    closeModal();
  };

  return (
    <div className={`${className} overflow-hidden h-full pb-5 relative`}>
      {/* Player List */}
      <ul className="max-h-[70%] overflow-y-scroll scrollbar-hide my-3 space-y-2">
        {players.map((player) => (
          <li key={player.id}>
            <Player
              player={player}
              onPlayerClick={setSelectedPlayer}
              onEditClick={(playerToEdit) => {
                setModal("set-role");
                setSelectedPlayer(playerToEdit);
              }}
              onDeleteClick={(playerToDelete) => {
                setModal("delete-player");
                setSelectedPlayer(playerToDelete);
              }}
            />
          </li>
        ))}
      </ul>

      {/* Add Player Button */}
      <Button
        onClick={() => {
          setModal("add-player");
        }}
        variant="blue"
      >
        <Text size="xxs" className="text-white">
          Add player
        </Text>
      </Button>

      {/* Modals */}
      {modal === "add-player" && (
        <AddPlayerModal
          className="absolute top-[50%] translate-y-[-80%] left-0 right-0"
          onClose={closeModal}
          onAdd={() => closeModal()}
        />
      )}

      {modal && selectedPlayer && (
        <div className="absolute bottom-10 left-0 right-0 w-full rounded-md top-10">
          {modal === "set-role" && (
            <SetRoleModal
              player={selectedPlayer}
              description={`For ${selectedPlayer.name}`}
              onSubmit={(player, newRole) => editPlayer(player, newRole)}
              onModalClose={closeModal}
            />
          )}

          {modal === "delete-player" && (
            <DeletePlayerModal
              player={selectedPlayer}
              onDeletePlayer={(playerToDelete) => deletePlayer(playerToDelete)}
              onClose={closeModal}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Players;
